import {DimensionValue, Dimensions, Platform, StyleSheet} from 'react-native';

const windowDim = Dimensions.get('window').width;

export const styles = StyleSheet.create({
  BoxShadowedContainer:
    Platform.OS === 'web'
      ? {
          margin: 12,
          padding: windowDim <= 400 ? 12 : 24,
          minWidth: windowDim <= 400 ? 'calc(100% - 24px)' as DimensionValue : 'calc(25% - 24px)' as DimensionValue,
          backgroundColor: 'white',
          borderRadius: 16,
          justifyContent: 'flex-start',
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
          elevation: 4,
        }
      : {
          backgroundColor: '#fff',
          ...Platform.select({
            ios: {
              shadowOffset: {width: 0, height: 2},
              shadowRadius: 4,
            },
            android: {
              elevation: 4,
            },
            web: {
              elevation: 4,
            },
          }),
          shadowColor: 'gray',
          shadowOpacity: 0.2,
          borderRadius: 20,
          paddingHorizontal: 10,
          paddingVertical: 20,
          margin: 10,
        },
});
